import React from 'react';
import { DefaultBackground, CobrandingComponents } from '../shared-cobranding';
import { CommunityLogo } from '../../../advanced-cobranding/community/assets/images/CommunityLogo';
import { AtlassianLogo } from '@atlaskit/logo';

const logoWrapperStyles = {
  display: 'flex',
  gap: '8px',
};

const CommunityCobranding: CobrandingComponents = {
  background: DefaultBackground,
  logo: {
    renderLogo: () => (
      <span style={logoWrapperStyles}>
        <AtlassianLogo appearance="brand" size="medium" />
        <span>
          <CommunityLogo />
        </span>
      </span>
    ),
  },
  footerProducts: 'Community, Jira, Confluence',
};

export default CommunityCobranding;
